import {ExceptionError} from '../exception'
import {Request} from '../request'
import {IApiResponse} from '../../interface/api-response/api-response'
import {API_PATH} from '../../constants/api-path'
import {IAnnouncement} from '../../interface/announcement'

export class GetAnnouncementService extends Request {
  async request(commpanyId: string) {
    try {
      const {data} = await this.client
        .get<IApiResponse<any>>(`${API_PATH.ANNOUNCEMENT}`, {})
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class CreateAnnouncementService extends Request {
  async request(payload: IAnnouncement) {
    const {data} = await this.client.post<any>(API_PATH.ANNOUNCEMENT, payload)
    try {
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class UpdateAnnouncementService extends Request {
  async request(payload: IAnnouncement) {
    try {
      const {data} = await this.client.post<any>(API_PATH.ANNOUNCEMENT, payload)
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
